'use client';

import { useQueryWithOnError } from '@/shared/hooks/query/useQueryWithOnError';
import { Skeleton } from '@/shared/ui/skeleton';
import { singleProject } from 'enteties/project/api';
interface MarketplaceTypeChipProps {
  slug: string;
}
export const MarketplaceTypeChip = ({
  slug
}: MarketplaceTypeChipProps) => {
  const {
    data: project,
    isLoading,
    isSuccess
  } = useQueryWithOnError({
    ...singleProject.getSingleProjectQueryOptions({
      slug
    })
  });
  if (isLoading) return <Skeleton className="h-4 w-24 bg-accent" />;
  if (!isSuccess) return <Skeleton className="h-4 w-24 bg-accent" />;
  if (project?.serviceType !== 'marketplace') return null;
  return <h4 className="text-body3 text-muted-foreground h-4" data-sentry-component="MarketplaceTypeChip" data-sentry-source-file="marketplace-type-chip.tsx">
      {project?.property?.meta?.toolchain?.name}
    </h4>;
};